import { apiClient } from './api';
import type {
  NormalizedOrder,
  NormalizedOrderListItem,
  NormalizedOrderNote,
  PaginatedResponse,
  BulkUpdateResponse,
  OrderStatus,
} from '@wooconnect/shared';

interface OrderFilters {
  page?: number;
  perPage?: number;
  status?: string;
  search?: string;
  after?: string;
  before?: string;
}

export async function getOrders(siteId: string, filters: OrderFilters): Promise<PaginatedResponse<NormalizedOrderListItem>> {
  const res = await apiClient.get(`/sites/${siteId}/orders`, { params: filters });
  return res.data.data;
}

export async function getOrder(siteId: string, orderId: number): Promise<NormalizedOrder> {
  const res = await apiClient.get(`/sites/${siteId}/orders/${orderId}`);
  return res.data.data;
}

export async function updateOrderStatus(siteId: string, orderId: number, status: OrderStatus): Promise<NormalizedOrder> {
  const res = await apiClient.put(`/sites/${siteId}/orders/${orderId}`, { status });
  return res.data.data;
}

export async function getOrderNotes(siteId: string, orderId: number): Promise<NormalizedOrderNote[]> {
  const res = await apiClient.get(`/sites/${siteId}/orders/${orderId}/notes`);
  return res.data.data;
}

export async function addOrderNote(siteId: string, orderId: number, note: string, customerNote = false): Promise<NormalizedOrderNote> {
  const res = await apiClient.post(`/sites/${siteId}/orders/${orderId}/notes`, { note, customerNote });
  return res.data.data;
}

export async function createRefund(siteId: string, orderId: number, amount: string, reason?: string) {
  const res = await apiClient.post(`/sites/${siteId}/orders/${orderId}/refund`, { amount, reason });
  return res.data.data;
}

export async function bulkUpdateOrders(siteId: string, orderIds: number[], status: OrderStatus): Promise<BulkUpdateResponse> {
  const res = await apiClient.post(`/sites/${siteId}/orders/bulk-update`, { orderIds, status });
  return res.data.data;
}
